import {Component, EventEmitter, Output} from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import {IdexService} from 'app/idex.service';
import {LogAssignDialogComponent} from '../log-assign-dialog/log-assign-dialog.component';
import {Toast} from '../../../shared/toast/toast';

@Component({
   selector: 'app-flow',
   templateUrl: './flow.component.html',
   styleUrls: ['./flow.component.css']
})
export class FlowComponent {
   @Output() workflowIdChange = new EventEmitter<any>();
   check: any [];
   showFlow = false;
   taskStatus: any;
   senderName: any;
   senderEmail: any;
   rejectBy: any;
   rejectDate: any;
   currentLevel: number;
   maxOrder: number;
   isTask: boolean;
   displayedColumns = ['order', 'signernum', 'signer'];
   dataSource: MatTableDataSource<FlowData>;
   flows: FlowData[];
   flowComplete: FlowData = {
      order: -1, numOfSigner: 0, totalSigners: 0, signerList: [{
         nameShow: '',
         signerName: '',
         signerEmail: '',
         action: '',
         originatorName: '',
         originatorEmail: '',
         signDate: '',
         taskReassigns: [],
         verifiedLv: '',
         taskContactId: 0
      }]
   };
   errorMessage: any;
   message = 'ttttfdsffd&#013fdfdf';
   taskId: number;

   constructor(public service: IdexService, private toast: Toast, private dialog: MatDialog) {
   }

   getFlowList(id: number) {
      if (id > 0) {
         if (this.isTask) {
            this.service.getTask(id, false)
               .subscribe((data) => {
                  this.taskId = data.taskId;
                  this.taskStatus = data.taskStatus;
                  this.senderName = data.senderName;
                  this.senderEmail = data.senderEmail;
                  this.currentLevel = data.currentLevel;
                  this.rejectBy = data.rejectBy;
                  this.rejectDate = data.rejectDate;
                  this.flows = data.apvLevel; // if signer name === reassign show reassign by originatorName,originatorEmail
                  this.maxOrder = 0;
                  for (let i = 0; i < this.flows.length; i++) {
                     if (this.maxOrder < this.flows[i].order) {
                        this.maxOrder = this.flows[i].order;
                     }
                  }
                  this.flows.push(this.flowComplete);
                  // Assign the data to the data source for the table to render
                  this.dataSource = new MatTableDataSource(this.flows);
                  this.showFlow = true;
                  this.workflowIdChange.emit(data);
               }, error => {
                  this.errorMessage = error;
               });
         } else {
            this.senderName = this.service.user.name;
            this.senderEmail = this.service.user.email;
            this.currentLevel = 0;
            this.service.getWorkflow(id)
               .subscribe((data) => {
                  this.flows = data.apvLevel;
                  this.maxOrder = 0;
                  for (let i = 0; i < this.flows.length; i++) {
                     if (this.maxOrder < this.flows[i].order) {
                        this.maxOrder = this.flows[i].order;
                     }
                  }
                  this.flows.push(this.flowComplete);
                  // Assign the data to the data source for the table to render
                  this.dataSource = new MatTableDataSource(this.flows);
                  this.showFlow = true;
                  this.workflowIdChange.emit(data);
               }, error => {
                  this.errorMessage = error;
               });
         }
      } else {
         this.showFlow = false;
         this.flows = [];
         this.dataSource = new MatTableDataSource(this.flows);
      }
   }

   getTotalSign(signerList: any) {
      let countTotalSign = 0;
      for (let i = 0; i < signerList.length; i++) {
         if (signerList[i].action === 'Need to Sign') {
            countTotalSign += 1;
         }
      }
      return countTotalSign;
   }

   setUl(signerLength: number) {
      if (this.isTask) {
         if (signerLength <= 2) {
            return 'ul-flow-less';
         }
      } else {
         if (signerLength <= 5) {
            return 'ul-flow-less';
         }
      }
      return 'ul-flow-more';

   }

   getIconLineTop(order: number) {
      if (this.taskStatus === 'Completed') {
         return 'assets/images/vertical_arrow_down_active.png';
      } else if (this.taskStatus === 'Draft') {
         return 'assets/images/vertical_arrow_down_inactive.png';
      } else if (order > 0 && order <= this.currentLevel) {
         return 'assets/images/vertical_arrow_down_active.png';
      } else {
         return 'assets/images/vertical_arrow_down_inactive.png';
      }

   }

   setli(signerLength: number) {
      if (signerLength >= 2) {
         return 'toolbar_more';
      }
      return '';
   }

   setWorkflow(signer: any, order: number) {
      if (this.taskStatus === 'Draft') {
         return 'wf-inactive';
      } else {
         if (signer.signDate !== '' && signer.signDate !== undefined) {
            return 'wf-sign';
         } else {
            if (this.taskStatus === 'Completed') {
               return 'wf-nonsign';
            } else {
               if ((signer.signDate === '' || signer.signDate === undefined) && order === this.currentLevel) {
                  if (this.taskStatus === 'Reject') {
                     if (signer.signerEmail === this.rejectBy) {
                        return 'wf-reject';
                     }
                     return 'wf-nonsign';
                  } else {
                     return 'wf-active';
                  }
               } else if ((signer.signDate === '' || signer.signDate === undefined) && order > this.currentLevel) {
                  if (this.taskStatus === 'Reject') {
                     return 'wf-nonsign';
                  } else {
                     return 'wf-inactive';
                  }
               } else if ((signer.signDate === '' || signer.signDate === undefined) && order < this.currentLevel) {
                  return 'wf-nonsign';
               }
            }
         }
      }
   }

   checkActionReject(signer: any) {
      if (this.rejectBy && signer.signerEmail.toLowerCase() === this.rejectBy.toLowerCase()
         && signer.stepOrder === this.currentLevel && this.rejectDate ) {
         return true;
      }
      return false;
   }

   checkActionSign(signer: any) {
      if ((!this.rejectBy || !(signer.signerEmail.toLowerCase() === this.rejectBy.toLowerCase()
         && signer.stepOrder === this.currentLevel))
         && signer.signDate !== '' && signer.signDate !== undefined) {
         return true;
      }
      return false;
   }

   checkAction(signer: any) {
      if ((!this.rejectBy || !(signer.signerEmail.toLowerCase() === this.rejectBy.toLowerCase()
         && signer.stepOrder === this.currentLevel))
         && (signer.signDate === '' || signer.signDate === undefined)) {
         return true;
      }
      return false;
   }

   setSender() {
      if (this.taskStatus === 'Draft') {
         return 'box-item-sender-inactive';
      } else if (this.isTask) {
         return 'box-item-sender-active';
      }
      return 'box-item-sender-inactive';
   }

   checkCompleted() {
      if (this.taskStatus === 'Completed') {
         return true;
      }
      return false;
   }

   getLogReassign(taskReassign: any) {
      this.service.logReassign(this.taskId).subscribe((response) => {
         // This is intentional.
      });

      const dialogRef = this.dialog.open(LogAssignDialogComponent, {
         disableClose: true,
         minHeight: '200px',
         width: '800px',
         data: {taskReassign},
      });
      dialogRef.afterClosed().subscribe(result => {
         // This is intentional.
      });

   }
}

export interface FlowData {
   order: number;
   numOfSigner: number;
   totalSigners: number;
   signerList: SignerData[];
}

export interface SignerData {
   nameShow: string;
   signerName: string;
   signerEmail: string;
   action: string;
   originatorName: string;
   originatorEmail: string;
   signDate: string;
   taskReassigns: any;
   verifiedLv: string;
   taskContactId: number;
}

export interface LogReassign {
   orderReassign: number;
   reassignFrom: string;
   reassignTo: string;
   reassignDate: string;
}
